module.exports = __webpack_public_path__ + "img/landscape-2278315_1920.5ee6d42c.jpg";